import * as React from 'react';
import * as Api from '../../api/src';
import { TextField, PrimaryButton, Icon, PersonaSize, PersonaPresence } from '@fluentui/react';
import { FileTypeAccept } from '../../common/constant/constantKey';
import { NoDataFound } from '../../control/noDataFound';
import { saveAs } from 'file-saver';
import { Avatar } from '../../control/avatar';
import { commonfn } from '../../common/commonfn';
import moment from 'moment';
import DocumentViewer from '../../control/DocumentViewer';
import Paging from '../../control/paging';
const MatrixMessagesAPi = new Api.MatrixMessagesApi();
const DocumentsApi = new Api.DocumentsApi();

interface MessagesProps {
  Id: number;
  IsLocked: boolean;
  OnChange: any;
}
const defaultPaging = { PageNumber: 1, PageSize: 20, SearchString: '' };
const Messages = ({ Id, IsLocked, OnChange }: MessagesProps) => {
  const [listMessages, setListMessages] = React.useState<Api.MessageDto[] | null | undefined>([]);
  const [listUsers, setListUsers] = React.useState<Api.User[] | null | undefined>([]);
  const [message, setMessage] = React.useState<string | undefined>('');
  const [files, setFiles] = React.useState<any>(null);
  const [isOpenDocument, SetIsOpenDocument] = React.useState(false);
  const [documentFile, SetDocumentFile] = React.useState<any>();
  const [messageParams, SetMessageParams] = React.useState<Api.GetPagedModuleMessagesQuery>(defaultPaging);
  const [messageData, setMessageData] = React.useState<Api.MessageDtoPaginatedResult>();

  React.useEffect(() => {
    getMessages();
  }, [Id]);
  React.useEffect(() => {
    getMessages();
  }, [messageParams]);
  const sendMessage = async () => {
    if (Id == 0 || (!message && !files)) return;
    const msg: Api.AddModuleMessageCommand = { Text: message, MatrixItemModuleId: Id };
    const result = (await MatrixMessagesAPi.apiMatrixMessagesMatrixModuleIdPost(Id.toString(), msg)).data;
    OnChange();
    if (result.Succeeded) {
      setMessage('');
      if (files) {
        const formData = new FormData();
        formData.append('documents', files);
        const fileResult = (
          await MatrixMessagesAPi.apiMatrixMessagesMatrixModuleIdMessageIdDocumentsPost(
            Id,
            result.Data?.Id || 0,
            formData as any,
          )
        ).data;
        getMessages();
        setFiles(null);
      } else {
        getMessages();
      }
    }
  };
  const downloadItem = (Item: Api.Document, preview?: boolean) => {
    if (preview) {
      SetDocumentFile(Item);
      SetIsOpenDocument(true);
      return;
    }
    if (!Item.Id) return;

    DocumentsApi.apiDocumentsIdGet(Item.Id || 0, {
      responseType: 'blob',
    }).then((response) => {
      const rs = response as any;
      saveAs((response as any).data as Blob, `${Item.Name}`);
    });
    //TestDocumentService.downloadFile(Item.Id, docId);
  };

  const getMessages = async () => {
    if (Id === 0) return;
    //let data = ((await MatrixMessagesAPi.apiMatrixMessagesMatrixModuleIdGet(Id)).data as Api.MessagesWithUserResult).Data;
    messageParams.MatrixModuleItemId = Id;
    let datas = (await MatrixMessagesAPi.apiMatrixMessagesMatrixModuleIdPagedPost(Id, messageParams))
      .data as Api.MessageDtoPaginatedResult;
    setMessageData(datas);
    //setListMessages(datas);
    //setListUsers(data?.Users);
  };

  const getUser = (id: number) => {
    const user = listUsers?.find((item) => {
      return item.Id === id;
    });
    return user;
  };

  const handleOnChange = (e: any) => {
    if (!Id) return;
    const formData = new FormData();
    for (let index = 0; index < e.target.files.length; index++) {
      const element = e.target.files[index];
      formData.append('documents ', element);
      setFiles(element);
    }
  };

  const checkImage = (name: string) => {
    const imgTypes = ['.png', '.jpg', '.jpeg', '.bmp'];
    if (name.match(/.(jpg|jpeg|png|gif)$/i)) {
      return true;
    }
    return false;
  };
  return (
    <div style={{ maxWidth: 1024 }}>
      {!IsLocked && (
        <div className="display-flex flex-column margin-top light-background group-textarea">
          <TextField
            label=""
            multiline
            rows={4}
            value={message}
            placeholder="Write your text here"
            onChange={(e, newValue) => {
              setMessage(newValue);
            }}
          />
          <div className="display-flex flex-justify-content-between padding" style={{ marginTop: 4 }}>
            <div>
              <a
                onClick={() => {
                  let a = document.getElementById('attachFile');
                  if (a) {
                    a.click();
                  }
                }}
              >
                <Icon iconName={'Attach'}></Icon> <span>{files ? files.name : ''}</span>
              </a>{' '}
              {files && (
                <a
                  onClick={() => {
                    setFiles(null);
                  }}
                >
                  <Icon iconName={'ChromeClose'}></Icon>
                </a>
              )}
              <input
                id="attachFile"
                accept={FileTypeAccept.FileAcceptTests}
                style={{ display: 'none' }}
                type="file"
                onChange={handleOnChange}
              />
            </div>
            <PrimaryButton
              className={''}
              disabled={!message && !files}
              onClick={() => {
                sendMessage();
              }}
            >
              {'Send'}
            </PrimaryButton>
          </div>
        </div>
      )}
      <br></br>

      <NoDataFound isShow={!messageData?.Data?.length} />
      {messageData?.Data?.map((item, i) => {
        const user = item.UserCreated; //getUser(item?.CreatedBy || 0);
        return (
          <div key={i}>
            <div className="display-flex message-row">
              <div className="avatar padding-right">
                <Avatar
                  keyColor={user?.Id?.toString() || ''}
                  imageInitials={commonfn.getNameInitial(user?.FullName)}
                  size={PersonaSize.size32}
                  hidePersonaDetails={true}
                  RandomColor={true}
                />
              </div>
              <div className="message-content">
                <div className="message-title display-flex flex-justify-content-between">
                  <div>
                    <div className="">
                      <b>{user?.FullName}</b>
                    </div>
                    <div className="sub-title">{user?.Email}</div>
                  </div>
                  <div className="sub-title">{moment(item?.CreatedOn).format('DD/MM/yyyy HH:mm')}</div>
                </div>
                <div className="message-detail">
                  {item.Text}
                  {item.Documents?.length ? (
                    <div style={{ marginTop: 8 }}>
                      {/* <NetworkImage /> */}
                      <a
                        onClick={() => {
                          if (item.Documents?.length) {
                            downloadItem(item.Documents[0], true);
                          }
                        }}
                      >
                        {checkImage(item.Documents[0].Name || '') ? (
                          // eslint-disable-next-line jsx-a11y/alt-text
                          <img
                            src={
                              process.env.REACT_APP_API_ENDPOINT +
                                '/api/Documents/' +
                                item.Documents[0].Id +
                                '/thumb/' +
                                item.Documents[0].Name || ''
                            }
                            height="60"
                            style={{ marginTop: 8 }}
                          ></img>
                        ) : (
                          <>
                            <Icon iconName={'Attach'}></Icon> {item.Documents[0].Name}
                          </>
                        )}
                      </a>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}
      <Paging
        CurrentPage={messageParams.PageNumber}
        TotalPage={messageData?.TotalPages || 0}
        onChangePage={(page, PageSize) => {
          SetMessageParams({ ...messageParams, PageNumber: page, PageSize: PageSize });
        }}
      ></Paging>
      {isOpenDocument && (
        <DocumentViewer
          Item={documentFile}
          IsOpen={isOpenDocument}
          onCloseModal={() => {
            SetIsOpenDocument(false);
          }}
        ></DocumentViewer>
      )}
    </div>
  );
};

export default Messages;
